export function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-text">403</h1>
        <p className="text-sm text-text-muted mt-2">
          You don't have permission to access this portal.
        </p>
        <a
          href="/login"
          className="inline-block mt-4 text-sm text-primary hover:underline"
        >
          Sign in with a different account
        </a>
      </div>
    </div>
  );
}
